"use client";

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const useCart = create(
  persist(
    (set, get) => ({
      items: [],
      addItem: (data: any) => {
        // const currentItems = get().items;
        // const existingItem = currentItems.find(item => item.id === data.id);

        // if(existingItem) {
        //     return toast.warning("Item already in cart.");
        // }

        set({ items: data });
        // toast.success("Item added to cart.");
      },
      removeItem: (data: any) => {
        set({ items: data });
        // toast.success("Item removed to cart.");
      },
      getCountInCart: ({
        cartItems,
        productId,
      }: {
        cartItems: any;
        productId: any;
      }) => {
        const foundItem = cartItems.find(
          (item: any) => item.productId === productId,
        );
        return foundItem ? foundItem.count : 0;
      },
      findLocalCartIndexById: ({
        array,
        productId,
      }: {
        array: any;
        productId: any;
      }) => {
        return array.findIndex((item: any) => item.productId === productId);
      },
      removeAll: () => set({ items: [] }),
    }),
    {
      name: "cart",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default useCart;
